/**
 * @copyright 2020 @ DigiNet
 * @author TAIAU
 * @create 07/13/2020
 * @Example
 */
import { Accordion as ExpansionPanel, AccordionDetails as ExpansionPanelDetails, AccordionSummary as ExpansionPanelSummary, Tab, Tabs, Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import withStyles from "@material-ui/core/styles/withStyles";
import { LoadPanel } from "devextreme-react";
import _ from "lodash";
import moment from 'moment';
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators, compose } from "redux";
import Config from "../../../../config";
import * as generalActions from "../../../../redux/general/general_actions";
import * as W06F0002Actions from "../../../../redux/W0X/W06F0002/W06F0002_actions";
import Attachments from "../../../common/attachments/attachments";
import ButtonGeneral from "../../../common/button/button-general";
import { Combo, MForm } from "../../../common/form-material";
import Icons from "../../../common/icons/";
import Modal from "../../../common/modal/modal";
import TabContent, { TabPanel } from "../../../common/tabs/tab-content";
import ActionToolbar from "../../../common/toolbar/action-toolbar";
import W06F0002GeneralInfo from "./W06F0002GeneralInfo";
import W06F0002Inventory from "./W06F0002Inventory";
import W06F0002ObjectCustomer from "./W06F0002ObjectCustomer";
import W06F0002OtherInfo from "./W06F0002OtherInfo";

const styles = theme => {
    return {
        iconArrowCollapse: {
            fontSize: 16,
            color: '#fff',
            backgroundColor: theme.palette.primary.main,
            borderRadius: '50%',
            justifyContent: 'center',
            height: 24,
            width: 24,
            marginRight: 8,
        },
        collapseBoardContent: {
            padding: '0 18px 32px',
            borderRadius: 4
        },
        heading: {
            fontSize: 12,
            fontWeight: 'bold',
            color: '#0095FF',
            textTransform: 'uppercase',
            transform: 'translateY(3px)'
        },
        collapseBoard: {
            boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
            marginBottom: '24px !important'
        },
        ExpansionPanelSummary: {
            padding: '0 18px',
            backgroundColor: '#F7F9FC',
            width: '100%',
            '& .MuiAccordionSummary-content': {
                margin: "12px 0 !important"
            },
            '&.Mui-expanded': {
                minHeight: 'inherit'
            }
        },
        yesNoContent: {
            margin: '12px 0 24px 0'
        },
        labelNumberFormat: {
            padding: "6.5px 0 !important",
            transform: "translateY(10px) !important"
        },
    };
};

class W06F0002 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSave: false,
            uploading: false,
            isUpdated: false,
            formLoading: false,
            loadApiStatus: true,
            expandedFirst: true,
            expandedSecond: true,
            expandedThird: false,
            disableSaveBtn: false,
            isEmptyInventory: false,
            modalContractTypes: false,
            modalContractTypesYesNo: false,
            mobileOnly: window.innerWidth < 576,
            contractTypesChosen: "",
            tabKey: 0,
            formData: {
                OTotal: 0,
                Ctotal: 0,
                Employee: null,
                ContractDate: moment().format("YYYY-MM-DD"), // Default Date
                StartDate: moment().format("YYYY-MM-DD"), // Default Date,
                ExceedContract: ''
            },
            errors: {},
            contractTypesData: {},
            fieldName: [],
            fieldValue: [],
            getAttachment: [],
            getInventoryList: [],
            activeInventoryColumn: []
        };
        this.TableName = "D49T2000-PO";
        this.formDataName = {};
        this.attachments = [];
        this.deletedFile = [];
        this.W06F0002Inventory = null;
        this.dataInfo = {
            mode: "",
            ContractID: "",
            isPermission: null,
            contractTypesChosenFromW06F0001: "",
            cboContractTypes: [],
            Mode: 0
        }
    }

    loadApi = (cboName, params = {}, ownAction = false) => {
        this.setState({ formLoading: true });
        this.props[ownAction ? "w06f0002Actions" : "generalActions"][cboName](params, (error, data = null) => {
            this.setState({ formLoading: false });
            if (error) {
                let message = error.message || Config.lang("ERP_Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            if (data) {
                this.handleDataApi(cboName, data);
            }
        });
    };

    handleDataApi = (cboName = "", data) => {
        let contractTypesData = {};
        const Language = this.Language;
        const { getDetailSupplement } = this.props;
        const { master, inventories, attachments } = data;
        const { mode, cboContractTypes } = this.dataInfo;
        switch (cboName) {
            case "loadForm": {
                if (mode !== "addFinal") {
                    contractTypesData = cboContractTypes && cboContractTypes.find(element => element.TransTypeID === master.TransTypeID);
                    this.setState({ contractTypesData })
                    if (!_.isEmpty(getDetailSupplement)) this.handleActiveInventoryColumn(getDetailSupplement, contractTypesData);
                }
                this.loadApi("getCboBankAccount", { ObjectTypeID: master.ObjectTypeID, ObjectID: master.ObjectID }, true);
                if (_.isEmpty(getDetailSupplement)) this.loadApi("getDetailSupplement", { Language }, true);
                if (master?.ExceedContract) {
                    master.ExceedContract = master.ExceedContract * 100;
                }
                this.setState({
                    getInventoryList: inventories,
                    getAttachment: attachments,
                    formData: {
                        ...master,
                        Employee: {
                            EmployeeID: master && master.EmployeeID ? master.EmployeeID : "",
                            EmployeeName: master && master.EmployeeName ? master.EmployeeName : master.EmployeeID,
                            UserPictureURL: master && master.UserPictureURL ? master.UserPictureURL : null,
                        }
                    }
                });
                if (!Config.isEmpty(master.CurrencyID, true)) {
                    const { CurrencyID } = master;
                    this.loadApi("getDeicimalQuantity", { CurrencyID }, true);
                }
                break;
            }
            case "loadCboCurrency": {
                if (data.length > 0) this.handleExchangeRateChange(data);
                break;
            }
            case "getDetailSupplement": {
                if (_.isEmpty(contractTypesData) && data.length > 0) {
                    contractTypesData = cboContractTypes.find(item => item.TransTypeID === this.state.formData.TransTypeID);
                    this.handleActiveInventoryColumn(data, contractTypesData);
                }
                break;
            }
            default:
                break;
        }
    }

    handleExchangeRateChange = (cboCurrency = []) => {
        const { formData } = this.state;
        const objCurrency = cboCurrency.find(item => item.CurrencyID === formData.CurrencyID);
        if (objCurrency && objCurrency.ExchangeRate) {
            formData.ExchangeRate = objCurrency.ExchangeRate;
            this.setState({ formData })
        }
    }

    handleActiveInventoryColumn = (data = [], contractTypesData = {}) => {
        const displayName = "Display";
        const activeInventoryColumn = data.filter((keyName) => {
            if (keyName.FieldName.includes("Str") && keyName.FieldName.includes("U")) {
                keyName.FieldName = keyName.FieldName.slice(0, -1) // Bỏ chứ U phía sau DisplayStr..U  vì Data trả về là DisplayStr..
            } else if (keyName.FieldName.includes("Dat")) {
                keyName.DefaultValueU = moment(keyName.DefaultValueU, "DD/MM/YYYY").format("YYYY-MM-DD");
            }
            return contractTypesData[displayName.concat(keyName.FieldName)] === 1;
        });
        this.setState({ activeInventoryColumn })
    }

    _getAttachments = () => {
        const listAttachments = Config.helpers.getFileInfomations(this.attachments);
        const { getAttachment } = this.state;
        let arrAttachment = [];
        listAttachments.forEach(att => {
            arrAttachment.push({
                URL: att.url || "",
                FileName: att.fileName || "",
                FileSize: att.fileSize || "",
                FileExt: att.fileExt || ""
            });
        });
        if (!_.isEmpty(getAttachment)) {
            arrAttachment = getAttachment.concat(arrAttachment);
        }
        return arrAttachment;
    };

    getInfo = async () => {
        const { location, getDetailSupplement } = this.props;
        if (location && !_.isEmpty(location.state)) {
            if (location.state.isPermission <= 0) return;
            await Config.checkRedirect(this.props.location.pathname); //Nếu có thì mới chạy check popup
            this.dataInfo.mode = location.state.mode || "add";
            this.dataInfo.isPermission = location.state.isPermission || null;
            this.dataInfo.ContractID = location.state.ContractID || "";
            this.dataInfo.cboContractTypes = location.state.cboContractTypes || [];
            this.dataInfo.contractTypesChosenFromW06F0001 = location.state.contractTypesChosen || "";
            this.dataInfo.Mode = location.state.Mode || 0;
            if (!_.isEmpty(location.state.cboContractTypes) && !_.isEmpty(location.state.contractTypesChosen) && location.state.mode === "addFinal") {
                const { contractTypesChosen, cboContractTypes } = location.state;
                const { formData } = this.state;
                const Language = this.Language;
                const contractTypesData = cboContractTypes && cboContractTypes.find(element => element.TransTypeID === contractTypesChosen);
                if (!Config.isEmpty(contractTypesData, true)) {
                    // Lấy CurrencyID và ContractTypeID default từ contractTypes đã chọn
                    const { ContractTypeID, CurrencyID } = contractTypesData;
                    formData.CurrencyID = CurrencyID;
                    formData.ContractTypeID = ContractTypeID;
                    if (!Config.isEmpty(CurrencyID, true)) this.loadApi("getDeicimalQuantity", { CurrencyID }, true);
                    if (Config.isEmpty(getDetailSupplement, true)) {
                        this.loadApi("getDetailSupplement", { Language }, true);
                    } else { //Lấy cột động
                        this.handleActiveInventoryColumn(getDetailSupplement, contractTypesData);
                    }
                    this.setState({ contractTypesData, formData })
                }
            }
        } else {
            this.setState({ loadApiStatus: false }, () => {
                browserHistory.push(Config.getRootPath() + "W06F0001");
                return null;
            })
        }
    };

    getExceedContract = () => {
        this.props.w06f0002Actions.getExceedContract({ Language: Config.language || 84 }, (error, data) => {
            if (error) {
                let message = error.message || Config.lang("ERP_Loi_chua_xac_dinh");
                Config.popup.show("INFO", message);
                return false;
            }
            this.setState({
                formData: {
                    ...this.state.formData,
                    ExceedContract: (data?.ExceedContract ?? 0) * 100
                }
            });
        });
    };

    componentDidUpdate(preProps) {
        const { mode } = this.dataInfo;
        if (JSON.stringify(preProps.getMasterSupplement) !== JSON.stringify(this.props.getMasterSupplement) && mode === 'addFinal') {
            const _formData = {};
            this.props.getMasterSupplement.forEach(item => {
                _formData[item.FieldName] = item.DefaultValueU;
            });
            this.setState({
                formData: {
                    ...this.state.formData,
                    ..._formData
                }
            });
        }
    }

    componentDidMount = async () => {
        await this.getInfo();
        if (this.state.loadApiStatus) {
            const { mode, ContractID, contractTypesChosenFromW06F0001, Mode } = this.dataInfo;
            const { getCboStatus, getCboCurrency, getCboPaymentMethod, paramsMasterSup, getMasterSupplement } = this.props;
            const Language = Config.language || "84";
            const TableName = this.TableName;
            if (mode === "edit" || mode === "copy") {
                this.loadApi("loadForm", { ContractID }, true);
            } else { // Add
                const userID = Config.profile.UserID || "";
                const user = Config.getUser({ UserID: userID });
                let _formData = {};
                if (!_.isEmpty(getMasterSupplement)) {
                    getMasterSupplement.forEach(item => {
                        _formData[item.FieldName] = item.DefaultValueU;
                    });
                }
                this.setState({
                    formData: {
                        ...this.state.formData,
                        TransTypeID: contractTypesChosenFromW06F0001,
                        EmployeeID: user && user.ObjectID ? user.ObjectID : "",
                        EStatus: 1,
                        ..._formData
                    }
                });
                this.getExceedContract();
            }
            if (mode === "edit" && ContractID) {
                this.loadApi("loadFormView", { ContractID, Language, Mode }, true); // Get Old Data Field Name
            }
            //General Info
            if (_.isEmpty(getCboPaymentMethod)) this.loadApi("loadCboPaymentMethod", {}, true);
            if (_.isEmpty(getCboCurrency)) {
                this.loadApi("loadCboCurrency", {}, true);
            } else {
                this.handleExchangeRateChange(getCboCurrency);
            }
            if (_.isEmpty(getCboStatus)) this.loadApi("loadCboStatus", { Language }, true);
            //Other Information 
            if (paramsMasterSup.TableName !== TableName) this.loadApi("getMasterSupplement", { TableName, Language }, true);
        }
    };

    componentWillUnmount = () => {
        const { location } = this.props;
        if (location && !_.isEmpty(location.state)) Config.unCheckRedirect();
        this.setState = (state, callback) => {
            return;
        };
    }

    setStateErrorText(objValue, key) {
        const stateError = key ? key : "errors";
        this.setState({
            [stateError]: { ...(this.state[stateError] ? this.state[stateError] : {}), ...objValue }
        });
        return Object.keys(objValue).length !== 0;
    }

    checkFileType = filename => {
        const extension = filename.substr(filename.lastIndexOf(".")).toLowerCase();
        const allowedExtensions = [".jpg", ".png"];
        if (extension.length > 0) {
            if (allowedExtensions.indexOf(extension) === -1) {
                return false;
            }
        }
        return true;
    };

    checkValid = (name, val, rules = ["isRequired"]) => {
        return { name, rules, value: val };
    };

    changeIDValueToName = (value) => {
        switch (value) {
            case "ContractTypeID": {
                value = "ContractTypeName"
                break;
            }
            case "EStatus": {
                value = "EStatusName"
                break;
            }
            case "EmployeeID": {
                value = "EmployeeName"
                break;
            }
            case "ObjectID": {
                value = "ObjectNameU"
                break;
            }
            case "PaymentMethodID": {
                value = "PaymentMethodName"
                break;
            }
            default:
                break;
        }
        return value;
    }

    getCodeLangMaster(ID, mode) {
        const { getMasterSupplement } = this.props;
        const masterSupDataField = getMasterSupplement.find(comboData => comboData.FieldName === ID);
        const listMasterValues = {
            //All
            OTotal: "ERP_Tong_gia_tri_hop_dong",
            Ctotal: "ERP_Tong_gia_tri_hop_dong_QD",
            //Tab General Information
            ContractTypeID: "ERP_Loai_hop_dong",
            ContractNo: "ERP_So_hop_dong",
            EStatus: "ERP_Trang_thai",
            CurrencyID: "ERP_Loai_tien",
            ExchangeRate: "ERP_Ty_gia",
            ContractDate: "ERP_Ngay_lap",
            EmployeeID: "ERP_Nguoi_lap",
            StartDate: "ERP_Ngay_bat_dau",
            EndDate: "ERP_Ngay_ket_thuc",
            PaymentMethodID: "ERP_Phuong_thuc_thanh_toan",
            ExceedContract: 'Dung_sai',
            //Tab Object Customer
            ObjectID: "ERP_Nha_cung_cap",
            ObjectAddressU: "ERP_Dia_chi",
            VATNo: "ERP_Ma_so_thue",
            BankAccountNo: "ERP_So_tai_khoan",
            TelNo: "ERP_So_dien_thoai",
            FaxNo: "ERP_So_Fax",
            NotesU: "ERP_Ghi_chu",
            GObjectName: "Don_vi_uy_thac",
        };
        let supMasterLanguage = ""
        if (masterSupDataField) {
            supMasterLanguage = mode === "vi" ? (masterSupDataField.Caption84 ? masterSupDataField.Caption84 : "") : (masterSupDataField.Caption01 ? masterSupDataField.Caption01 : "");
        }
        return listMasterValues[ID] ? listMasterValues[ID] : supMasterLanguage;
    }

    getCodeLangInventory(ID, mode) {
        const { activeInventoryColumn } = this.state;
        const detailSupDataField = activeInventoryColumn.find(comboData => comboData.FieldName === ID);
        const listIventoryValues = {
            UnitID: "ERP_Don_vi_tinh",
            Quantity: "ERP_So_luong",
            UnitPrice: "ERP_Don_gia",
            OAmount: "ERP_Thanh_tien",
            CAmount: "ERP_Thanh_tien_QD",
            PackingMethodID: "ERP_Quy_cach_dong_goi",
            PackingMethodName: "ERP_Quy_cach_dong_goi",
            PackingTypeID: "ERP_Loai_bao_dong_goi",
            PackingTypeName: "ERP_Loai_bao_dong_goi",
            Specification: "ERP_Tieu_chuan_chat_luong",
        };
        let supDetailLanguage = ""
        if (detailSupDataField) {
            supDetailLanguage = mode === "vi" ? (detailSupDataField.Caption84 ? detailSupDataField.Caption84 : "") : (detailSupDataField.Caption01 ? detailSupDataField.Caption01 : "");
        }
        return listIventoryValues[ID] ? listIventoryValues[ID] : supDetailLanguage;
    }

    onSaveHistory = async (newDataMaster, newAttachment, newInventory) => {
        const { oldDataInventories, oldDataMaster, oldDataAttachments, loadFormInvenView, loadFormView } = this.props;
        const formDataName = this.formDataName;
        const { mode, ContractID } = this.dataInfo;
        let data = []; //Chứa giá trị bị thay đổi

        /// <=======@@@@@@========> LƯU CHỈNH SỬA (MASTER, ATTACHMENT, INVENTORIES)  <=======@@@@@@========>
        if (mode === "edit") {
            /// <=======@@@@@@========> LƯU CHỈNH SỬA MASTER  <=======@@@@@@========>
            const masterKey = Object.keys(newDataMaster);
            const excludeFields = ['Employee', 'GObjectID', 'GObjectTypeID'];
            masterKey.forEach((value) => {
                if (!excludeFields.includes(value) &&
                    (newDataMaster[value] !== (value !== 'ExceedContract' ? oldDataMaster[value] : oldDataMaster[value] / 100))) {
                    // console.log("Đây chính là Chỉnh sửa Master trong Mode EDIT");
                    const descriptionVi = this.getCodeLangMaster(value, "vi");
                    const descriptionEn = this.getCodeLangMaster(value, "en");
                    const changeIDValueToName = this.changeIDValueToName(value);
                    const oldValue = loadFormView[changeIDValueToName] ? loadFormView[changeIDValueToName] : "";
                    const newValue = formDataName[value] ? formDataName[value] : newDataMaster[value];
                    if (_.isEmpty(oldValue) && _.isEmpty(newValue) && value !== 'ExceedContract') return;
                    let el = {};
                    el.codeID = newDataMaster.ContractID;
                    el.formID = "W06F0001";
                    el.type = "text";
                    el.linkedTrans = "";
                    el.oldValue = oldValue;
                    el.newValue = newValue;
                    el.description84 = Config.lang(descriptionVi, "vi");
                    el.description01 = Config.lang(descriptionEn, "en");
                    el.action = 1;
                    data.push(el);
                }
            });

            /// <=======@@@@@@========> LƯU INVENTORIES - MODE: "EDIT" <=======@@@@@@========>
            if (!_.isEmpty(newInventory) && !_.isEmpty(oldDataInventories)) {
                let newDataInventoryValuesID = [];
                let inventoriesFieldName = [];
                inventoriesFieldName = loadFormInvenView.map(jaja => Object.keys(jaja))[0];
                newDataInventoryValuesID = newInventory.map(item => item.PurchaseItemID);
                /// <=====================> Lưu Xóa Inventories - MODE: "EDIT" <=====================>
                loadFormInvenView.forEach((dataCu) => {
                    if ((newDataInventoryValuesID.indexOf(dataCu.PurchaseItemID) === -1)) {
                        // console.log("Đây chính là Xóa Hàng Hóa trong Mode EDIT");
                        let el = {};
                        el.codeID = dataCu.ContractID;
                        el.formID = "W06F0001";
                        el.linkedTrans = "";
                        el.oldValue = dataCu.InventoryID + "-" + dataCu.InventoryNameU;
                        el.newValue = "";
                        el.description84 = Config.lang("ERP_Hang_hoa", "vi");
                        el.description01 = Config.lang("ERP_Hang_hoa", "en");
                        el.action = 3;
                        data.push(el);
                    }
                })
                /// <=====================> Lưu Chỉnh sửa Inventories - MODE: "EDIT" <=====================>
                newInventory.forEach((dataMoi) => {
                    loadFormInvenView.forEach(dataCu => {
                        inventoriesFieldName.forEach(fieldName => {
                            if (!_.isUndefined(dataMoi[fieldName]) && dataMoi.PurchaseItemID === dataCu.PurchaseItemID && dataMoi[fieldName] !== dataCu[fieldName]) {
                                // console.log("Đây chính là Chỉnh sửa hàng hóa trong Mode EDIT");
                                const descriptionVi = this.getCodeLangInventory(fieldName, "vi");
                                const descriptionEn = this.getCodeLangInventory(fieldName, "en");
                                let el = {};
                                el.codeID = newDataMaster.ContractID;
                                el.formID = "W06F0001";
                                el.type = "text";
                                el.linkedTrans = "";
                                el.oldValue = dataCu[fieldName];
                                el.newValue = dataMoi[fieldName];
                                el.description84 = Config.lang(descriptionVi, "vi") + " (" + Config.lang("ERP_Hang_hoa", "vi") + ": " + dataCu.InventoryID + "-" + dataCu.InventoryNameU + ")";
                                el.description01 = Config.lang(descriptionEn, "en") + " (" + Config.lang("ERP_Hang_hoa", "en") + ": " + dataCu.InventoryID + "-" + dataCu.InventoryNameU + ")";
                                el.action = 1;
                                data.push(el);
                            }
                        });
                    });
                });
                if (!_.isEmpty(newInventory)) {
                    /// <=====================> Lưu Thêm Mới INVENTORIES - MODE: "EDIT" <=====================>
                    let dataNewInventoryPurchaseItemID = [];
                    dataNewInventoryPurchaseItemID = loadFormInvenView.map(item => item.PurchaseItemID);
                    newInventory.forEach((dataMoi) => {
                        if (dataNewInventoryPurchaseItemID.indexOf(dataMoi.PurchaseItemID) === -1) {
                            // console.log("Đây chính là Add new hàng hóa trong Mode EDIT");
                            let el = {};
                            el.codeID = newDataMaster.ContractID;
                            el.formID = "W06F0001";
                            el.linkedTrans = "";
                            el.oldValue = "";
                            el.newValue = dataMoi.InventoryID + "-" + dataMoi.InventoryNameU;
                            el.description84 = Config.lang("ERP_Hang_hoa", "vi");
                            el.description01 = Config.lang("ERP_Hang_hoa", "en");
                            el.action = 2;
                            data.push(el);
                        }
                    });
                }
            }
            /// <=======@@@@@@========> LƯU INVENTORIES - MODE: "EDIT" <=======@@@@@@========>
            if (!_.isEmpty(newInventory) && !_.isEmpty(loadFormInvenView)) {
                /// <=====================> Lưu Xóa ATTACHMENT - MODE: "EDIT" <=====================>
                let newDataInventoryValuesID = [];
                newDataInventoryValuesID = newAttachment.map(item => item.URL);
                oldDataAttachments.forEach((dataCu) => {
                    if ((newDataInventoryValuesID.indexOf(dataCu.URL) === -1)) {
                        // console.log("Đây chính là Xóa Tệp đính kèm trong Mode EDIT");
                        let el = {};
                        el.codeID = newDataMaster.ContractID;
                        el.formID = "W06F0001";
                        el.linkedTrans = "";
                        el.oldValue = dataCu.FileName;
                        el.newValue = "";
                        el.description84 = Config.lang("ERP_Dinh_kem", "vi");
                        el.description01 = Config.lang("ERP_Dinh_kem", "en");
                        el.action = 3;
                        data.push(el);
                    }
                })
            }
            if (!_.isEmpty(newAttachment)) {
                /// <=====================> Lưu Thêm Mới ATTACHMENT - MODE: "EDIT" <=====================>
                let dataOldAttachmentURL = [];
                dataOldAttachmentURL = oldDataAttachments.map(item => item.URL);
                newAttachment.forEach((dataMoi) => {
                    if (dataOldAttachmentURL.indexOf(dataMoi.URL) === -1) {
                        // console.log("Đây chính là Add new Tệp đính kèm trong Mode EDIT");
                        let el = {};
                        el.codeID = newDataMaster.ContractID;
                        el.formID = "W06F0001";
                        el.linkedTrans = "";
                        el.oldValue = "";
                        el.newValue = dataMoi.FileName;
                        el.description84 = Config.lang("ERP_Dinh_kem", "vi");
                        el.description01 = Config.lang("ERP_Dinh_kem", "en");
                        el.action = 2;
                        data.push(el);
                    }
                });
            }
        }
        /// <=======@@@@@@========> LƯU CHỈNH SỬA (MASTER, ATTACHMENT, INVENTORIES)  <=======@@@@@@========>


        /// <=======@@@@@@========> LƯU THÊM MỚI (MASTER, ATTACHMENT, INVENTORIES)  <=======@@@@@@========>
        else { // MODE === addFinal or MODE === copy
            /// <=====================> Lưu Thêm Mới MASTER - MODE: "ADD" <=====================>
            let el = {};
            el.codeID = ContractID;
            el.formID = "W06F0001";
            el.linkedTrans = "";
            el.oldValue = "";
            el.newValue = newDataMaster.ContractNo;
            el.description84 = Config.lang("ERP_Hop_dong", "vi");
            el.description01 = Config.lang("ERP_Hop_dong", "en");
            el.action = 0;
            data.push(el);
            if (!_.isEmpty(newInventory)) {/// <=====================> Lưu Thêm Mới INVENTORIES - MODE: "ADD" <=====================>
                newInventory.forEach((dataMoi) => {
                    // console.log("Đây chính là Add new hàng hóa trong Mode ADD");
                    let el = {};
                    el.codeID = ContractID;
                    el.formID = "W06F0001";
                    el.linkedTrans = "";
                    el.oldValue = "";
                    el.newValue = dataMoi.InventoryID + "-" + dataMoi.InventoryNameU;
                    el.description84 = Config.lang("ERP_Hang_hoa", "vi");
                    el.description01 = Config.lang("ERP_Hang_hoa", "en");
                    el.action = 2;
                    data.push(el);
                });
            }
            if (!_.isEmpty(newAttachment)) {/// <=====================> Lưu Thêm Mới ATTACHMENT - MODE: "ADD" <=====================>
                newAttachment.forEach((dataMoi) => {
                    // console.log("Đây chính là Add new tệp đính kèm trong Mode ADD");
                    let el = {};
                    el.codeID = ContractID;
                    el.formID = "W06F0001";
                    el.linkedTrans = "";
                    el.oldValue = "";
                    el.newValue = newAttachment.FileName;
                    el.description84 = Config.lang("ERP_Dinh_kem", "vi");
                    el.description01 = Config.lang("ERP_Dinh_kem", "en");
                    el.action = 2;
                    data.push(el);
                });
            }
        }
        //Format Date Time Value 
        const valueFieldName = ["newValue", "oldValue"];
        valueFieldName.forEach(fieldName => {
            data.forEach(obj => {
                if (Config.isValidDateTime(obj[fieldName])) {
                    obj[fieldName] = moment.utc(obj[fieldName], "YYYY-MM-DD").format("DD/MM/YYYY");
                }
            })
        })
        if (data.length > 0) {
            const param = {
                attributes: JSON.stringify(data),
            };
            await this.props.w06f0002Actions.saveHistoryData(param, (error, data) => {
                this.setState({ formLoading: false, isSave: false });
                if (error) {
                    let message = error.message || Config.lang("ERP_Luu_lich_su_khong_thanh_cong");
                    Config.popup.show("INFO", message);
                    return false;
                }
                if (data) {
                    this.saveSuccessAction();
                }
            });
        } else {
            this.saveSuccessAction();
        }
    };

    saveSuccessAction = async () => {
        await Config.unCheckRedirect();
        this.setState({ disableSaveBtn: true, formLoading: false, isUpdated: false }, () => {
            Config.notify.show("success", Config.lang("ERP_Luu_thanh_cong"), 2000);
            setTimeout(() => {
                const { isPermission, ContractID, contractTypesChosenFromW06F0001: contractTypesChosen = "", cboContractTypes } = this.dataInfo;
                browserHistory.push({
                    pathname: Config.getRootPath() + "W06F0003",
                    state: {
                        mode: 'view',
                        ContractID,
                        cboContractTypes,
                        contractTypesChosen,
                        isPermission
                    }
                })
            }, 0);
        });
    }

    getDataSave = () => {
        const { formData } = this.state;
        const { mode } = this.dataInfo;
        let _formData = { ...formData };
        if (mode === "addFinal") {
            const { getMasterSupplement } = this.props;
            getMasterSupplement.forEach(item => {
                const formDataKeyName = Object.keys(_formData);
                if (item.DefaultUse === 1 && !_.isEmpty(item.DefaultValueU) && formDataKeyName.indexOf(item.FieldName) < 0) {
                    const { FieldName, DefaultValueU, DataType } = item;
                    const checkValue = DataType === "datetime" ? moment(DefaultValueU).format("YYYY-MM-DD") : DefaultValueU;
                    _formData[FieldName] = checkValue;
                }
            });
        }
        Object.keys(_formData).forEach(dataMaster => {
            if (Config.isValidDateTime(_formData[dataMaster])) {
                _formData[dataMaster] = moment(_formData[dataMaster]).format("YYYY-MM-DD")
            }
        });
        if (_formData.hasOwnProperty('Employee')) delete _formData.Employee;
        if (_formData.hasOwnProperty('EmployeeName')) delete _formData.EmployeeName;
        _formData.ExceedContract = _formData.ExceedContract / 100;
        return _formData;
    };

    onSave = async () => {
        let checkReqiredData = false;
        const { getInventoryList } = this.state;
        let dataSourceInventory = getInventoryList;
        if (this.W06F0002Inventory) {
            await this.W06F0002Inventory.instance.saveEditData();
            dataSourceInventory = this.W06F0002Inventory.instance.option("dataSource");
            await new Promise(resolve => setTimeout(resolve, 500));
        }
        const { location, oldDataInventories } = this.props;
        const { formData, isEmptyInventory, tabKey } = this.state;
        const mode = _.get(location, "state.mode", "edit");
        const apiSave = mode === "addFinal" || mode === "copy" ? "saveAddNew" : "saveEdit";
        const {
            TransTypeID,
            ContractID,
            EmployeeID,
            ContractNo,
            ContractTypeID,
            EStatus,
            CurrencyID,
            ContractDate,
            StartDate,
            EndDate,
            ExchangeRate,
            ObjectID
        } = formData;
        const fContractTypeID = this.checkValid("ContractTypeID", ContractTypeID);
        const fContractDate = this.checkValid("ContractDate", ContractDate);
        const fTransTypeID = this.checkValid("TransTypeID", TransTypeID);
        const fCurrencyID = this.checkValid("CurrencyID", CurrencyID);
        const fEmployeeID = this.checkValid("EmployeeID", EmployeeID);
        const fContractNo = this.checkValid("ContractNo", ContractNo);
        const fStartDate = this.checkValid("StartDate", StartDate);
        const fCObjectID = this.checkValid("ObjectID", ObjectID);
        const fEStatus = this.checkValid("EStatus", EStatus);
        const fEndDate = this.checkValid("EndDate", EndDate);
        const fExchangeRate = this.checkValid("ExchangeRate", ExchangeRate ? ExchangeRate : (0).toString());
        const validateForm = MForm.formValidation([
            fTransTypeID,
            fEmployeeID,
            fContractNo,
            fContractTypeID,
            fEStatus,
            fCurrencyID,
            fContractDate,
            fStartDate,
            fEndDate,
            fExchangeRate,
            fCObjectID
        ]);
        let dataMasterFormat = this.getDataSave();
        await dataSourceInventory.forEach(item => {
            const { Quantity, UnitPrice } = item;
            if (_.isNull(Quantity) || _.isUndefined(UnitPrice) || _.toNumber(Quantity) === 0 || _.toNumber(UnitPrice) === 0) {
                checkReqiredData = true;
            }
        });
        if (Object.keys(validateForm).length > 0) {
            this.setStateErrorText(validateForm);
            if (tabKey !== 0) this.setState({ tabKey: 0 })
            return false;
        } else if (isEmptyInventory || _.isEmpty(dataSourceInventory)) {
            if (tabKey !== 1) this.setState({ tabKey: 1 })
            Config.popup.show("INFO", Config.lang("ERP_Vui_long_chon_hang_hoa"));
            return false;
        } else if (checkReqiredData) {
            if (tabKey !== 1) this.setState({ tabKey: 1 })
            Config.popup.show("INFO", Config.lang("ERP_Vui_long_nhap_so_luong_va_gia_hang_hoa"));
            return false;
        } else {
            if (this.W06F0002Inventory) {
                await this.W06F0002Inventory.instance.saveEditData();
                dataSourceInventory = this.W06F0002Inventory.instance.option("dataSource");
            }
            dataSourceInventory.forEach(data => {
                Object.keys(data).forEach(key => {
                    if (data[key] && Config.isValidDateTime(data[key])) {
                        data[key] = moment(data[key]).format("YYYY-MM-DD")
                    }
                });
            });
            const arrAttachments = this._getAttachments();
            const arrayInvenIDNew = dataSourceInventory.map(inven => inven.PurchaseItemID);
            const arrayInvenIDOld = oldDataInventories.map(inven => inven.PurchaseItemID);
            let removed = oldDataInventories.filter(inven => arrayInvenIDNew.indexOf(inven.PurchaseItemID) < 0);
            const added = dataSourceInventory.filter(inven => arrayInvenIDOld.indexOf(inven.PurchaseItemID) < 0);
            const edited = dataSourceInventory.filter(inven => arrayInvenIDOld.indexOf(inven.PurchaseItemID) > -1);
            let params = {};
            if (ContractID && mode === "edit") {
                params = {
                    ContractID: ContractID,
                    Language: Config.language || "84",
                    master: JSON.stringify(dataMasterFormat),
                    detail: JSON.stringify({
                        OTotal: dataMasterFormat.OTotal,
                        CTotal: dataMasterFormat.Ctotal,
                        inventories: {
                            removed: removed,
                            added: added,
                            edited: edited
                        }
                    }),
                    attachments: JSON.stringify(arrAttachments)
                };
            } else { // add or copy run api insert
                params = {
                    Language: Config.language || "84",
                    master: JSON.stringify(dataMasterFormat),
                    detail: JSON.stringify({
                        OTotal: dataMasterFormat.OTotal,
                        CTotal: dataMasterFormat.Ctotal,
                        inventories: dataSourceInventory
                    }),
                    attachments: JSON.stringify(arrAttachments)
                };
            }
            this.setState({ formLoading: true, isSave: true });
            this.props.w06f0002Actions[apiSave](params, (error, data) => {
                if (error) {
                    let defaultMessage = Config.lang("ERP_Loi_chua_xac_dinh");
                    const errorCodeList = ["W06F0000E203"];
                    if (apiSave === "saveAddNew" && error) {
                        switch (error.code) {
                            case "W06F0000E203":
                                defaultMessage = Config.lang("ERP_So_hop_dong_da_ton_tai");
                                break;
                            case null:
                            case "null":
                                defaultMessage = Config.lang("ERP_Khong_ton_tai");
                                break;
                            default:
                                defaultMessage = Config.lang("ERP_Luu_khong_thanh_cong");
                                break;
                        }
                    }
                    Config.popup.show("INFO", errorCodeList.includes(error.code) ? defaultMessage : error.message);
                    this.setState({ formLoading: false, isSave: false });
                    return false;
                }
                if (data) {
                    if (data.ContractID) this.dataInfo.ContractID = data.ContractID;
                    this.onSaveHistory(dataMasterFormat, arrAttachments, dataSourceInventory)
                }
            });
        }
    };

    calculateDepCAmount = (ExchangeRate) => {
        const { getInventoryList, formData } = this.state;
        getInventoryList.forEach(item => {
            const { UnitPrice, Quantity } = item;
            if (_.isUndefined(Quantity) && _.isUndefined(UnitPrice)) return;
            item.CAmount = Quantity * UnitPrice * ExchangeRate;
        })
        formData.Ctotal = formData.OTotal * ExchangeRate;
    }

    onChange = (e, nameField) => {
        const value = _.isObject(e) ? _.get(e, "value", _.get(e, "target.value", e ? e : "")) : e;
        const { formData } = this.state;
        if (nameField === "ExchangeRate" && formData.ExchangeRate !== value) {
            this.calculateDepCAmount(value);
        }
        this.setState({
            isUpdated: true,
            formData: {
                ...formData,
                [nameField]: !_.isNull(value) ? value : ""
            }
        });
    };

    onChangeFormData = (value, nameField) => {
        const { formData } = this.state;
        formData[nameField] = value;
        if (!this.state.isUpdated) this.setState({ isUpdated: true })
    };

    onChangeCbo = (valueName, nameField) => {
        if (_.isNull(valueName)) return;
        if (!this.state.isUpdated) this.setState({ isUpdated: true });
        this.formDataName = {
            ...this.formDataName,
            [nameField]: valueName
        }
    };

    onLoading = (yesNo) => {
        this.setState({ formLoading: yesNo });
    }

    onAttachment = () => {
        if (this.attRef) {
            this.attRef.onAttachment();
        }
    };

    onChangeAttachments = e => {
        this.attachments = e.uploadedFiles ? e.uploadedFiles : [];
        if (e.deletedFiles && e.deletedFiles.length > 0) {
            this.deletedFile = [...e.deletedFiles];
            const _arrRemove = this.deletedFile.map(d => d.URL);
            this.setState(prevState => ({
                getAttachment: prevState.getAttachment.filter(att => {
                    return _arrRemove.indexOf(att.URL) < 0;
                })
            }));
        }
        if (!this.state.isUpdated) this.setState({ isUpdated: true })
    };

    onUploading = value => {
        this.setState({ uploading: value });
    };

    onBack = () => {
        if (this.state.isUpdated) {
            Config.popup.show("YES_NO", Config.lang("ERP_Du_lieu_chua_duoc_luu_ban_co_muon_tiep_tuc_khong"), () => {
                browserHistory.goBack();
            });
        } else {
            browserHistory.goBack();
        }
    }

    handleTabChange = (e, key) => {
        if (this.W06F0002Inventory) {
            this.W06F0002Inventory.instance.saveEditData();
        }
        this.setState({ tabKey: key });
    };

    onCloseModal = () => {
        const { formData } = this.state;
        if (!formData.TransTypeID) return;
        this.setState({
            modalContractTypes: false
        });
    };

    onChangeTranType = (e) => {
        this.setState({ contractTypesChosen: e.value });
    }

    loadContractNo = (ContractTypeID) => {
        if (_.isEmpty(ContractTypeID) || _.isUndefined(ContractTypeID)) return;
        const { formData } = this.state;
        let ContractNo = "";
        if (ContractTypeID) {
            const params = { ContractTypeID };
            this.setState({ formLoading: true });
            this.props.w06f0002Actions.getContractNo(params, (errors, data) => {
                if (errors) {
                    formData.ContractNo = "";
                    this.setState({ formLoading: false, formData });
                    let message = errors.message || Config.lang("ERP_Loi_chua_xac_dinh");
                    Config.popup.show("INFO", message);
                    return false;
                }
                if (data && data.ContractNo) {
                    ContractNo = data.ContractNo;
                    formData.ContractNo = ContractNo;
                    this.setState({ formData, formLoading: false })
                }
            });
        }
    };

    onSaveTranType = () => {
        const { getCboCurrency, getDetailSupplement, getCboContractType } = this.props;
        const { formData, contractTypesChosen } = this.state;
        const { cboContractTypes, mode } = this.dataInfo;
        const contractTypesData = cboContractTypes.find(item => item.TransTypeID === contractTypesChosen);
        if (mode === "addFinal" && !_.isEmpty(getCboContractType)) { // Lấy CurrencyID và ContractTypeID default từ contractTypes đã chọn
            const { ContractTypeID, CurrencyID } = contractTypesData;
            const objCurrency = getCboCurrency.find(item => item.CurrencyID === CurrencyID);
            formData.CurrencyID = CurrencyID;
            formData.ContractTypeID = ContractTypeID;
            formData.ExchangeRate = !_.isUndefined(objCurrency) ? objCurrency.ExchangeRate : 0;
            if (!Config.isEmpty(CurrencyID, true)) this.loadApi("getDeicimalQuantity", { CurrencyID }, true);
            const loadContractNo = (getCboContractType.find(item => item.ContractTypeID === formData.ContractTypeID)).Auto === 1;
            this.setState(prevState => {
                return ({
                    isUpdated: true,
                    modalContractTypes: false,
                    contractTypesChosen: "",
                    contractTypesData,
                    formData: {
                        ...formData,
                        ContractNo: loadContractNo ? formData.ContractNo : "",
                        TransTypeID: prevState.contractTypesChosen
                    }
                })
            }, () => {
                if (loadContractNo) this.loadContractNo(contractTypesData.ContractTypeID)
                this.handleActiveInventoryColumn(getDetailSupplement, contractTypesData);
            })
        }
    }

    render() {
        const { formData, errors, expandedFirst, expandedSecond, expandedThird, modalContractTypesYesNo, getAttachment, contractTypesData, activeInventoryColumn,
            formLoading, tabKey, modalContractTypes, error, contractTypesChosen, getInventoryList, disableSaveBtn, mobileOnly, uploading, isSave } = this.state;
        const { classes, getDecimalQuantity } = this.props;
        const { cboContractTypes, isPermission } = this.dataInfo;
        const { TransTypeID } = formData;
        const { mode } = this.dataInfo;
        const line = !_.isEmpty(contractTypesData.TransTypeName) ? "-" : "";
        if (isPermission <= 0) return null;
        return (
            <>
                <LoadPanel
                    shadingColor={'rgba(0,0,0,0.4)'}
                    position={{ my: 'center', of: '#content' }}
                    visible={isSave}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                />
                <Modal open={modalContractTypes}
                    maxWidth={"sm"}
                    fullWidth={true}
                    position={"center"}>
                    <Modal.Title disableTypography>
                        <div className={"display_row align-center align-between flex-wrap"} style={{ width: '100%' }}>
                            <div className={"display_row align-center"}>
                                <Typography variant={"h6"} className={"mgr10 text-uppercase"}>{Config.lang("ERP_Nghiep_vu")}</Typography>
                            </div>
                            <IconButton
                                aria-label={"close"}
                                size={"small"}
                                onClick={this.onCloseModal} >
                                <Icons name={"cancel_filled"} />
                            </IconButton>
                        </div>
                    </Modal.Title>
                    <Modal.Content>
                        <Row>
                            <Col xs={12} sm={12} md={3} lg={3} style={{ transform: 'translateY(5px)' }}>
                                {Config.lang("ERP_Loai_nghiep_vu")}<span style={{ color: 'red' }}>&nbsp;*</span>
                            </Col>
                            <Col xs={12} sm={12} md={9} lg={9}>
                                <Combo
                                    error={error && error["TransTypeID"]}
                                    // displayExpr={"TransTypeName"}
                                    displayExpr={(e) => {
                                        if (!e) return null;
                                        const line = !_.isEmpty(e.TransTypeName) ? "-" : "";
                                        return `${e.TransTypeID} ${line} ${e.TransTypeName}`;
                                    }}
                                    stylingMode={"underlined"}
                                    valueExpr={"TransTypeID"}
                                    margin={"none"}
                                    dataSource={cboContractTypes}
                                    disabled={formLoading}
                                    value={TransTypeID}
                                    required={true}
                                    shrink={true}
                                    itemRender={(e) => {
                                        if (!e) return null;
                                        const line = !_.isEmpty(e.TransTypeName) ? "-" : "";
                                        return `${e.TransTypeID} ${line} ${e.TransTypeName}`;
                                    }}
                                    onValueChanged={(e) => this.onChangeTranType(e)}
                                />
                            </Col>
                        </Row>
                        <ButtonGeneral name={Config.lang("ERP_Dong_y")}
                            size={"large"}
                            color={"primary"}
                            variant={"contained"}
                            disabled={formLoading || !contractTypesChosen}
                            style={{ textTransform: 'uppercase', float: 'right', marginTop: 12 }}
                            onClick={this.onSaveTranType} />
                    </Modal.Content>
                </Modal>
                <Modal open={modalContractTypesYesNo}
                    maxWidth={"sm"}
                    fullWidth={true}
                    position={"center"}>
                    <Modal.Content style={{ textAlign: 'center' }}>
                        <div className={classes.yesNoContent}>{Config.lang("ERP_Nghiep_vu_da_co_du_lieu")}</div>
                        <Row>
                            <ButtonGeneral
                                name={Config.lang("ERP_Huy")}
                                size={"large"}
                                color={"primary"}
                                variant={"outlined"}
                                disabled={formLoading}
                                style={{ textTransform: 'uppercase', marginRight: 24 }}
                                onClick={() => this.setState({ modalContractTypesYesNo: false })} />
                            <ButtonGeneral
                                name={Config.lang("ERP_Dong_y")}
                                size={"large"}
                                color={"primary"}
                                variant={"contained"}
                                disabled={formLoading}
                                style={{ textTransform: 'uppercase' }}
                                onClick={() => this.setState({ modalContractTypes: true, modalContractTypesYesNo: false })} />
                        </Row>
                    </Modal.Content>
                </Modal>

                <ActionToolbar
                    allwaysTop
                    title={Config.lang("ERP_Chi_tiet_hop_dong_mua")}
                    onBack={this.onBack}>
                    <div style={{ display: mobileOnly ? '' : 'inline-flex' }}>
                        <Col xs={6} sm={6} md={6} lg={6}>
                            <ButtonGeneral
                                name={Config.lang("ERP_Luu")}
                                size={"large"}
                                typeButton={"save"}
                                style={{ textTransform: 'uppercase' }}
                                disabled={formLoading || disableSaveBtn}
                                onClick={this.onSave}
                            />
                        </Col>
                        <Col xs={6} sm={6} md={6} lg={6} {...(window.innerWidth >= 768 ? { style: { textAlign: 'right', position: 'absolute', right: 0 } } : {})} >
                            {!_.isEmpty(contractTypesData) &&
                                <ButtonGeneral
                                    name={`${contractTypesData.TransTypeID} ${line} ${contractTypesData.TransTypeName}`}
                                    typeButton={"custom_edit"}
                                    reverseIcon={true}
                                    className={"bg_none"}
                                    variant={"custom"}
                                    size={"large"}
                                    style={{ textTransform: "uppercase", maxWidth: '100%', justifyContent: 'end' }}
                                    disabled={mode !== "addFinal"}
                                    onClick={() => this.setState({ modalContractTypesYesNo: true })}
                                />}
                        </Col>
                    </div>
                </ActionToolbar>
                <Tabs
                    value={tabKey}
                    component={"div"}
                    scrollButtons={"off"}
                    textColor={"primary"}
                    variant={"scrollable"}
                    indicatorColor={"primary"}
                    aria-label={"full width tabs"}
                    style={{ fontSize: '16px' }}
                    onChange={this.handleTabChange}
                >
                    <Tab href={""} label={Config.lang("ERP_Thong_tin_chung")} />
                    <Tab href={""} label={Config.lang("ERP_Hang_hoa")} />
                </Tabs>
                <TabContent
                    style={{ paddingBottom: 10, backgroundColor: '#fff' }}
                    activeKey={tabKey}
                    disableSwipe={true}
                    lazyLoading={false}
                    onChangeIndex={this.handleChangeIndex}>
                    <TabPanel index={0}>
                        {((mode !== "addFinal" ? !_.isEmpty(formData.ContractID) : true) && (mode !== "addFinal" ? !_.isEmpty(getDecimalQuantity) : true)) &&
                            <React.Fragment>
                                <div style={{ padding: '0px 3px 0px 3px', width: '100%' }}>
                                    <ExpansionPanel
                                        expanded={expandedFirst}
                                        className={classes.collapseBoard}
                                        onChange={() => this.setState({ expandedFirst: !expandedFirst })}
                                    >
                                        <ExpansionPanelSummary className={classes.ExpansionPanelSummary} >
                                            <i className={"fa display_row align-center " + (expandedFirst ? "fa-angle-down " : "fa-angle-right ") + classes.iconArrowCollapse} />
                                            <Typography className={classes.heading}>{Config.lang("ERP_Thong_tin_chung")}</Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className={classes.collapseBoardContent}>
                                            <W06F0002GeneralInfo
                                                mode={mode}
                                                errorForm={errors}
                                                formData={formData}
                                                loading={formLoading}
                                                onLoading={(yesNo) => this.onLoading(yesNo)}
                                                onChange={(e, name) => this.onChange(e, name)}
                                                onChangeCbo={(valueName, fieldName) => this.onChangeCbo(valueName, fieldName)}
                                                classes={classes}
                                            />
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    <ExpansionPanel
                                        expanded={expandedSecond}
                                        className={classes.collapseBoard}
                                        onChange={() => this.setState({ expandedSecond: !expandedSecond })}
                                    >
                                        <ExpansionPanelSummary
                                            className={classes.ExpansionPanelSummary}
                                        >
                                            <i className={"fa display_row align-center " + (expandedSecond ? "fa-angle-down " : "fa-angle-right ") + classes.iconArrowCollapse} />
                                            <Typography className={classes.heading}>
                                                {Config.lang("ERP_Nha_cung_cap")}
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className={classes.collapseBoardContent}>
                                            <W06F0002ObjectCustomer
                                                mode={mode}
                                                errorForm={errors}
                                                formData={formData}
                                                onSave={this.onSave}
                                                loading={formLoading}
                                                onChange={(e, name) => this.onChange(e, name)}
                                                onChangeCbo={(valueName, fieldName) => this.onChangeCbo(valueName, fieldName)}
                                                contractTypesData={contractTypesData}
                                                loadApi={this.loadApi}
                                            />
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>
                                    <ExpansionPanel
                                        expanded={expandedThird}
                                        className={classes.collapseBoard}
                                        onChange={() => this.setState({ expandedThird: !expandedThird })}
                                    >
                                        <ExpansionPanelSummary
                                            className={classes.ExpansionPanelSummary}
                                        >
                                            <i className={"fa display_row align-center " + (expandedThird ? "fa-angle-down " : "fa-angle-right ") + classes.iconArrowCollapse} />
                                            <Typography className={classes.heading}>
                                                {Config.lang("ERP_Thong_tin_khac")}
                                            </Typography>
                                        </ExpansionPanelSummary>
                                        <ExpansionPanelDetails className={classes.collapseBoardContent}>
                                            <W06F0002OtherInfo
                                                mode={mode}
                                                formData={formData}
                                                loading={formLoading}
                                                onChange={(e, name) => this.onChange(e, name)}
                                            />
                                        </ExpansionPanelDetails>
                                    </ExpansionPanel>

                                    <div style={{ width: '100%', marginTop: '20px' }}>
                                        <Row>
                                            <Col xs={12}>
                                                <Attachments
                                                    showButton={true}
                                                    files={getAttachment}
                                                    uploading={formLoading}
                                                    loading={uploading || formLoading}
                                                    onUploading={this.onUploading}
                                                    ref={ref => (this.attRef = ref)}
                                                    onChanged={this.onChangeAttachments}
                                                />
                                            </Col>
                                        </Row>
                                        <ButtonGeneral
                                            name={Config.lang("ERP_Dinh_kem")}
                                            typeButton={"attachment"}
                                            variant={"outlined"}
                                            size={"large"}
                                            loading={formLoading}
                                            style={{ textTransform: "uppercase", marginTop: 7 }}
                                            onClick={this.onAttachment}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    </TabPanel>
                    <TabPanel index={1} lazyLoading={true}>
                        <React.Fragment>
                            <W06F0002Inventory
                                mode={mode}
                                formData={formData}
                                formDataList={getInventoryList}
                                contractTypesData={contractTypesData}
                                activeInventoryColumn={activeInventoryColumn}
                                isUpdatedStatus={this.state.isUpdated}
                                isUpdated={() => {
                                    if (!this.state.isUpdated) this.setState({ isUpdated: true })
                                }}
                                gridRef={ref => this.W06F0002Inventory = ref}
                                onChangeFormData={(e, name) => this.onChangeFormData(e, name)}
                                onChangeInventories={(getInventoryList) => {
                                    this.setState({ getInventoryList, isEmptyInventory: false })
                                    if (getInventoryList.length < 1) {
                                        this.setState({ isEmptyInventory: true })
                                    }
                                }}
                            />
                        </React.Fragment>
                    </TabPanel>
                </TabContent>
            </>
        );
    }
}
export default compose(
    connect(
        (state) => ({
            oldDataMaster: state.W06F0002.oldDataMaster,
            oldDataAttachments: state.W06F0002.oldDataAttachments,
            oldDataInventories: state.W06F0002.oldDataInventories,
            getMasterSupplement: state.W06F0002.getMasterSupplement,
            getDecimalQuantity: state.W06F0002.getDecimalQuantity,
            loadFormView: state.W06F0002.loadFormView,
            loadFormInvenView: state.W06F0002.loadFormInvenView,
            getDetailSupplement: state.W06F0002.getDetailSupplement,
            getCboStatus: state.W06F0002.getCboStatus,
            getCboCurrency: state.W06F0002.getCboCurrency,
            getCboPaymentMethod: state.W06F0002.getCboPaymentMethod,
            paramsMasterSup: state.W06F0002.paramsMasterSup,
            getCboContractType: state.W06F0002.getCboContractType,
        }),
        dispatch => ({
            generalActions: bindActionCreators(generalActions, dispatch),
            w06f0002Actions: bindActionCreators(W06F0002Actions, dispatch)
        })
    ),
    withStyles(styles, { withTheme: true })
)(W06F0002);
